import React from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import Chip from "../Chip/Chip";
import { COLORS } from "../../constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * CustomCallout Component for Web with React Native Web
 *
 * @param {Object} props - Component properties.
 * @param {string} props.title - The title displayed in the InfoWindow.
 * @param {string} props.subtitle - The subtitle displayed in the InfoWindow.
 * @param {Object} [props.chipProps] - Optional properties for the Chip component.
 * @param {Function} props.onPress - Callback for navigation on callout click.
 * @returns {JSX.Element} A styled InfoWindow displaying the title, subtitle, and optional chip.
 */
const CustomCallout = ({ title, subtitle, chipProps, onPress, parkingIndicator }) => {
  return (
    <TouchableOpacity onPress={onPress} style={styles.touchable}>
      <View style={styles.container}>
        {/* Title */}
        {title && <Text style={styles.title}>{title}</Text>}

        {/* Parking Indicator */}
        {parkingIndicator && parkingIndicator}

        {/* Subtitle */}
        {subtitle && <Text style={styles.subtitle}>{subtitle}</Text>}

        {/* Optional Chip */}
        {chipProps && (
          <View style={styles.chipWrapper}>
            <Chip
              title={chipProps.title}
              icon={chipProps.icon}
              onPress={chipProps.onPress}
              backgroundColor={chipProps.backgroundColor}
              textColor={chipProps.textColor}
              iconColor={chipProps.iconColor}
              borderColor={chipProps.borderColor}
              size={"lg"}
              type={chipProps.type}
              FontAwesomeIcon={FontAwesomeIcon}
            />
          </View>
        )}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  touchable: {
    cursor: "pointer",
  },
  container: {
    padding: 8,
    backgroundColor: COLORS.textLight,
    maxWidth: 500,
  },
  title: {
    fontSize: 16,
    fontWeight: "bold",
    color: COLORS.textDark,
    marginBottom: 5,
    lineHeight: 24,
  },
  subtitle: {
    fontSize: 14,
    color: COLORS.border,
    lineHeight: 22,
  },
  chipWrapper: {
    marginTop: 8,
  },
});

export default CustomCallout;
